import { Controller } from '@hotwired/stimulus'

// DrillDown Toolbar
// - when you add a level it removes [disabled] from the input (allowing it to
//   be submitted as part of the form)
// - we move the input+button to the end of the toolbar so it is in order
// - we then update the data-depth=0 values to include the new level

export default class extends Controller {
    static targets = ['dropdownMenuButton', 'dropdownMenuItem', 'input']

    connect() {
        this.#updateDepths()
    }

    showLevel(event) {
        const input = this.#toggleLevel(event.params.level)
        const toolbarButton = input.nextElementSibling
        // Inserts the level element to the end of the toolbar
        this.dropdownMenuButtonTarget.insertAdjacentElement('beforebegin', input)
        this.dropdownMenuButtonTarget.insertAdjacentElement('beforebegin', toolbarButton)
        this.#updateDepths()
    }

    hideLevel(event) {
        this.#toggleLevel(event.params.level)
    }

    #toggleLevel(level) {
        this.#toggleDropdownMenuItem(level)

        // Show/hide level button in the toolbar
        const input = this.inputTargets.find((input) => input.value == level)
        input?.toggleAttribute('disabled')
        return input
    }

    // We use data-depth on active buttons to determine their background color
    #updateDepths() {
        const activeInputs = this.inputTargets.filter((input) => !input.disabled)
        activeInputs.forEach((button, index) => {
            button = button.nextElementSibling
            button.dataset.depth = index
        })
    }

    // FIXME: the dropdown toggled state should be managed via outlets in
    // another controller, this is a pattern we're using elsewhere and this
    // currently has some issues (not toggling icons properly)
    #toggleDropdownMenuItem(level) {
        // Enable/disable level option in the dropdown menu
        const dropdownMenuItem = this.dropdownMenuItemTargets.find(
            (dropdownMenuItem) => dropdownMenuItem.dataset.level == level,
        )
        dropdownMenuItem?.classList.toggle('disabled')
        dropdownMenuItem?.classList.toggle('d-none')
    }
}
